import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'authentication',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.scss'],
})
export class AuthenticationComponent {
  @Input() configuration;
  @Input() isLoggingIn: boolean;

  form: UntypedFormGroup = new UntypedFormGroup({});

  @Output() loginFormSubmitted = new EventEmitter();

  login() {
    if (this.form.valid) {
      this.loginFormSubmitted.emit(this.form.value);
    } else {
      Object.keys(this.form.controls).forEach((key) => {
        this.form.get(key).markAsTouched();
      });
    }
  }
}
